/**
 * Safari applies hash history a turn too late. popstate runs while
 * location.hash is still the page being left, and hashchange often never
 * fires for entries created with pushState. React Router's hash history
 * then keeps a location that matches no route, so the shell stays and the
 * page outlet is empty. Dispatching hashchange after the hash settles lets
 * that listener read the real URL. A second pass covers a late update.
 * The history listener ignores the event when the path is already current.
 */
export function scheduleHashHistorySync() {
  const dispatch = () => {
    const EventCtor =
      typeof window.HashChangeEvent === "function"
        ? window.HashChangeEvent
        : window.Event;
    window.dispatchEvent(new EventCtor("hashchange"));
  };

  window.setTimeout(() => {
    dispatch();
    window.requestAnimationFrame(dispatch);
  }, 0);
}

export function installSafariHashHistorySync() {
  const onPopState = () => scheduleHashHistorySync();
  const onPageShow = (event) => {
    if (event.persisted) scheduleHashHistorySync();
  };

  window.addEventListener("popstate", onPopState);
  window.addEventListener("pageshow", onPageShow);
  return () => {
    window.removeEventListener("popstate", onPopState);
    window.removeEventListener("pageshow", onPageShow);
  };
}
